import { render, staticRenderFns } from "./OptionsCategoryCell.vue?vue&type=template&id=53e2d099&scoped=true&"
import script from "./OptionsCategoryCell.vue?vue&type=script&lang=js&"
export * from "./OptionsCategoryCell.vue?vue&type=script&lang=js&"
import style0 from "./OptionsCategoryCell.vue?vue&type=style&index=0&id=53e2d099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2d099",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle})
